import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ResetAssetsLifecycleMutationVariables = Types.Exact<{
  input: Types.ResetArchiveFromForAssetsInput;
  page?: Types.PageInput;
}>;


export type ResetAssetsLifecycleMutation = { __typename?: 'Mutation', resetArchiveFromForAssets?: { __typename?: 'ResetArchiveFromForAssetsPayload', assets?: { __typename?: 'AssetConnection', totalCount: number } | null } | null };


export const ResetAssetsLifecycle = /*#__PURE__*/ gql`
    mutation ResetAssetsLifecycle($input: ResetArchiveFromForAssetsInput!, $page: PageInput! = {first: 0}) {
  resetArchiveFromForAssets(input: $input) {
    assets(page: $page) {
      totalCount
    }
  }
}
    ` as unknown as DocumentNode<ResetAssetsLifecycleMutation, ResetAssetsLifecycleMutationVariables>;

          

          export const useResetAssetsLifecycleMutation = (options?:MutationHookOptions<ResetAssetsLifecycleMutation, ResetAssetsLifecycleMutationVariables>) => useMutation(ResetAssetsLifecycle, options);
          

          export type ResetAssetsLifecycleMutationOptions = MutationHookOptions<ResetAssetsLifecycleMutation, ResetAssetsLifecycleMutationVariables>;

          

          export type ResetAssetsLifecycleMutationResult = ReturnType<typeof useResetAssetsLifecycleMutation>[1];

          
